var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 27099",
    fill: "currentColor",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39615",
    clipPath: "url(#star_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17514",
    d: "M24.961 32a1.5 1.5 0 01-.725-.187L16 27.26l-8.236 4.553a1.5 1.5 0 01-2.206-1.555l1.59-9.745-6.722-6.889a1.5 1.5 0 01.848-2.53l9.226-1.41L14.642.862a1.5 1.5 0 012.716 0L21.5 9.684l9.228 1.41a1.5 1.5 0 01.848 2.53l-6.722 6.889 1.59 9.745A1.5 1.5 0 0124.961 32M16 24.046a1.5 1.5 0 01.726.187l6.258 3.459-1.215-7.443a1.5 1.5 0 01.407-1.289l5.212-5.341-7.134-1.09a1.5 1.5 0 01-1.131-.846L16 5.03l-3.123 6.653a1.5 1.5 0 01-1.131.846l-7.134 1.09 5.212 5.341a1.5 1.5 0 01.407 1.289l-1.215 7.443 6.258-3.459a1.5 1.5 0 01.726-.187",
    fill: "currentColor"
  }))));
}
export default SvgStar;